import React from 'react';
import { translations } from '../Text/translations';
import WhatsappIcon from '../../../../../images/icon/icon-whatsapp.svg';
import phoneCallIcon from '../../../../../images/icons/phone-call.svg';
import maxActivationImage from '../../assets/max/Max-Activation.png';

const StbMaxEnquiry = ({ currentLang }) => {
    const handleWhatsappClick = () => {
        window.location.href =
            'https://api.whatsapp.com/send?phone=85296133533&text=%E6%88%91%E6%83%B3%E6%9F%A5%E8%A9%A2%E9%97%9C%E6%96%BCHBO+Max%E4%B9%8B%E7%9B%B8%E9%97%9C%E7%B5%84%E5%90%88%E8%A9%B3%E6%83%85%E3%80%82+I+would+like+to+inquire+the+details+of+Now+TV+x+HBO+Max+service+plan.&utm_source=DiscoverPage&utm_medium=Banner&utm_campaign=DiscoverPage';
    };

    return (
        <>
            <div className='max-contact-wrapper stb-enquiry'>
                <div className='container'>
                    <hr />
                    <h3>{translations[currentLang].maxContactUs}</h3>

                    <div className='contact-items-wrapper'>
                        <div className='item'>
                            <a onClick={handleWhatsappClick}>
                                <div className='img-wrap'>
                                    <img src={WhatsappIcon} alt='' className='whatsapp' />
                                </div>
                                <h5>{translations[currentLang].maxWhatsAppEnquiry}</h5>
                            </a>
                        </div>

                        <div className='item'>
                            <a href={currentLang === 'en' ? 'tel:28880008' : 'tel:28881888'}>
                                <div className='img-wrap'>
                                    <img src={phoneCallIcon} alt='' className='phone' />
                                </div>
                                <h5>
                                    {translations[currentLang].maxCall}
                                    <br />
                                    {translations[currentLang].maxDial}
                                </h5>
                            </a>
                        </div>
                    </div>

                    <img src={maxActivationImage} alt="" className="preview-img addMargin" />
                </div>
            </div>
        </>
    );
};

export default StbMaxEnquiry;
